<template>
    <template v-if="loading">
        <div class="o-spinning-coin"></div>
    </template>
    <template v-else>
        <template v-if="error">
            <p>{{ error }} ({{ errorCode }})</p>
        </template>
        <template v-else>
            <h1>{{ order.order_number }}</h1>
        </template>
    </template>
</template>
<script>
import axios from 'axios'

export default {
    name: 'CheckoutSuccess',
    data () {
        return {
            order: {},
            token: null,
            error: null,
            errorCode : null,
            loading: true,
            pages: window.ajax_var.pages
        }
    },
    methods: {
        updateInvoice(){
            //get token in url

            if(this.$store.state.token) {
                this.token = this.$store.state.token
            } else {
                location.href = '/'
            }
            let params = {
                token: this.token,
                _wpnonce: window.ajax_var.nonce
            }
            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.post('/wp-json/stereostore/v1/cart/success', params)
                .then(response => {
                    this.order = response.data.data
                    location.href = this.pages.invoice+'?token='+this.order.token
                    try{
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'purchase',
                            'ecommerce': {
                                'currency': window.ajax_var.currency,
                                'items': this.order.items.map(item => {
                                    return {
                                        'id': item.product_id,
                                        'name': item.name,
                                        'price': item.price,
                                        'quantity': item.quantity,
                                        'variant': item.sku
                                    }
                                })
                            }
                        });
                    }catch(e){
                        console.log(e)
                    }
                    this.$store.commit('deleteToken')
                    this.loading = false
                })
                .catch(error => {
                    console.log(error)
                    this.error = error.response.data.message
                    this.errorCode = error.response.data.code
                    this.loading = false
                })
        },
    },
    mounted () {
        this.updateInvoice()
    }
}
</script>